import { useNavigate } from "react-router-dom";
import { handleAnswer } from "../../../../utils/Functions";

const HealthAssessmentSection: React.FC<{
    keyParameters: {
        value: string[];
        emoji: string;
        name: string;
        questionId: string;
    }[]
}> = ({
    keyParameters,
}) => {
        const navigate = useNavigate()
        return (
            <div className="space-y-[20px]">
                <div className="w-full flex items-center justify-between">
                    <div className="font-bold text-[14px]">
                        📝 In evidenza dal tuo Health Assessment
                    </div>
                    <div
                        className="font-bold text-[12px] text-holifya-blue cursor-pointer hidden md:block"
                        onClick={() => navigate("/check-up-assessment-home-page")}
                    >
                        Rispondi check-up
                    </div>
                </div>
                <div className="grid grid-cols-3 gap-[10px] md:grid-cols-6">
                    {
                        keyParameters.map((param, index) => (
                            <div
                                key={index}
                                className={`w-full shadow-platform rounded-[15px] aspect-square p-[10px] space-y-[10px] ${param.name === "Obiettivo" ? "bg-[#C2D9FF]" : "bg-white"} cursor-pointer`}
                                onClick={() => navigate(`/edit-question?question_id=${param.questionId}&answer=${param.value.join(";;")}&from_health_plan=${true}`)}
                            >
                                <div className="font-bold text-[12px] leading-[33px]">{param.emoji} {param.name}</div>
                                <div
                                    className={`${param.name === "Obiettivo"
                                        ? "font-bold text-[22px] leading-[26px]"
                                        : param.name === "Peso"
                                            ? "font-semiboldbold text-[40px] leading-[40px]"
                                            : "font-bold text-[16px] leading-[22px]"
                                        } 
                                        break-words`}
                                >
                                    {
                                        param.name === "Peso"
                                            ? <>
                                                {handleAnswer(param.name.toLowerCase(), param.value[0]).split(' ')[0]}
                                                <span className="ml-[10px] font-bold text-[18px] leading-[24px]">{handleAnswer(param.name.toLowerCase(), param.value[0]).split(' ')[1]}</span>
                                            </>
                                            : handleAnswer(param.name.toLowerCase(), param.value[0])
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div
                    className="font-bold text-[12px] text-holifya-blue cursor-pointer md:hidden"
                    onClick={() => navigate("/check-up-assessment-home-page")}
                >
                    Rispondi check-up
                </div>
            </div>
        )
    }

export default HealthAssessmentSection
